import api from './axios';

const providerCatalogRequests = {
  getAll() {
    return api.get('/catalog/providers');
  },
};

export default providerCatalogRequests;
